import { render } from "./BaseBadget.vue?vue&type=template&id=95a197f2&scoped=true"
import script from "./BaseBadget.vue?vue&type=script&lang=js"
export * from "./BaseBadget.vue?vue&type=script&lang=js"

import "./BaseBadget.vue?vue&type=style&index=0&id=95a197f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a197f2"]])

export default __exports__